import { Box, Paper, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import { createOrganisation } from '@/domain/organisation/actions/create-organisation.action';
import { Organisation } from '@/domain/organisation/entities/organisation.entity';
import { selectIsCreatingOrganisation } from '@/domain/organisation/organisation.selectors';
import FairlyBackgroundLogo from '@/ui/assets/logo-fairly-background.png';
import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { Logo } from '@/ui/components/Logo';
import { useAppDispatch, useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';
import { OrganisationForm } from '@/ui/pages/app/organisation/components/OrganisationForm';

export function CreateOrganisation() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const isCreatingOrganisation = useAppSelector(selectIsCreatingOrganisation);

  const initialOrganisationState: Organisation = {
    id: -1,
    logo: '',
    name: '',
    type: '',
    activity: '',
    location: '',
    address: '',
    zipCode: '',
    country: '',
    website: '',
  };

  const onClickCreate = async (data: Organisation) => {
    try {
      const params = { organisation: data };
      await dispatch(createOrganisation(params)).unwrap();
      navigate('/app/welcome', { replace: true }); // replace avoid the user to come back in this page with previous browser button
    } catch (error) {
      console.error(error);
    }
  };

  const formButton = (
    <Box sx={{ mt: 2, mb: 1, display: 'flex', justifyContent: 'end' }}>
      <FSPrimaryButton disabled={isCreatingOrganisation} type="submit">
        {translate('Form.create')}
      </FSPrimaryButton>
    </Box>
  );

  return (
    <Box
      sx={{
        height: '100vh',
        background: `no-repeat url(${FairlyBackgroundLogo})`,
        backgroundSize: 'contain',
      }}
    >
      <Stack
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 6,
        }}
      >
        <Box sx={{ mt: 8 }}>
          <Logo />
        </Box>
        <Paper
          elevation={3}
          sx={{
            padding: '20px',
            borderRadius: '28px',
            width: '100%',
            maxWidth: 500,
            mb: 6,
          }}
        >
          <Stack spacing={3}>
            <Typography variant="h6">
              {translate('CreateOrganisation.create-your-organisation')}
            </Typography>
            <Box>
              <OrganisationForm
                organisation={initialOrganisationState}
                buttons={formButton}
                onSubmit={onClickCreate}
              />
            </Box>
          </Stack>
        </Paper>
      </Stack>
    </Box>
  );
}
